// extracted by mini-css-extract-plugin
export default {"cell":"XTIea_YJVVKHGqK8zW_H","yellow":"GxXNQSBZZMg5Pw1poUNx","red":"dI0GJr91o8XKoNzAhbln","green":"xWD9pVQ9I5RGcYCbZkcj"};